export const DEFAULT_FORM_VALIDATIONS = {
  criteriaMode: 'all',
  mode: 'all',
  reValidateMode: 'onChange',
} as const;
